import { ConfigProvider, notification } from "antd";

notification.config({
  placement: "topRight",
  maxCount: 1,
});

export default function AntdConfigProvider({ children }) {
  return <ConfigProvider>{children}</ConfigProvider>;
}
